export default "__VITE_ASSET__DVKX2tId__"